import React from 'react';
import Styles from './TrainingDrawerMenu.module.less';
import { Drawer } from '../../../Drawer';
import { Logotype } from '../../../Logotype';
import { TrainingMenuContent } from '../TrainingMenu';
import { CloseOutlined } from '@ant-design/icons';
import { TrainingDataType } from '../../../../lib/landingPage';
import { classes } from '../../../../lib';

export type TrainingDrawerMenuProps = {
    trainingMenu: TrainingDataType;
    visible: boolean;
    setMenuVisible: (visible: boolean) => void;
};

export const TrainingDrawerMenu = ({
    trainingMenu,
    visible,
    setMenuVisible,
}: TrainingDrawerMenuProps) => {
    return (
        <Drawer
            closable={false}
            placement="left"
            bodyStyle={{ padding: 0, overflowX: 'hidden' }}
            closeIcon={null}
            width={256}
            visible={visible}
            onClose={() => setMenuVisible(false)}>
            <div
                className={classes(
                    Styles.drawerHeader,
                    'pl24 horizontal left-middle'
                )}>
                <Logotype className={Styles.logotype} type="WhiteSnowLogo" />
            </div>
            <div
                className="p16 vertical g16"
                onClick={() => setMenuVisible(false)}>
                <TrainingMenuContent trainingMenu={trainingMenu} />
            </div>
            <div className={Styles.closeIcon}>
                <CloseOutlined
                    onClick={() => setMenuVisible(false)}
                    hidden={!visible}
                />
            </div>
        </Drawer>
    );
};
